import classNames from 'classnames'
import { describeTypePolicyBadge } from '../../utils'
import type { TypePolicyBadgeProps } from './type-policy-badge.interface'
import classes from './type-policy-badge.module.scss'

export function TypePolicyBadge({ appointmentType }: TypePolicyBadgeProps) {
  const label = describeTypePolicyBadge(appointmentType)
  return (
    <span className={classNames(classes.badge, { [classes.none]: label === 'None' })} data-testid="type-policy-badge">
      {label}
    </span>
  )
}
